export const GET_PERSON = "GET_PERSON";
export const GET_PERSON_SUCCESS = "GET_PERSON_SUCCESS";
export const CLEAN_PERSON = "CLEAN_PERSON";

export const API_ON_ERROR = "API_ON_ERROR";
export const NOT_FOUND_IN_BD = "NOT_FOUND_IN_BD";
export const SAVE_USER_DATA = "SAVE_USER_DATA";
export const SEND_LEAD = "SEND_LEAD";
export const SAVE_LEAD_DATA = "SAVE_LEAD_DATA";
export const CLEAN_STATUS = "CLEAN_STATUS";
export const INIT_SETTING_DATA = "INIT_SETTING_DATA";
export const GET_PERSON_DATA = "GET_PERSON_DATA";
export const INIT_STATE = "INIT_STATE";
export const SAVE_STEP = "SAVE_STEP"
export const IS_NEW_CLIENT = "IS_NEW_CLIENT";

export const EXPERIMENT_STEP_PLANS = "EXPERIMENT_STEP_PLANS";
export const EXPERIMENT_STEP_DATA = "EXPERIMENT_STEP_DATA";
export const EXPERIMENT_STEP_PAYMENT = "EXPERIMENT_STEP_PAYMENT";
export const SET_EXPERIMENT_QUOTE = "SET_EXPERIMENT_QUOTE";

export const SET_ADVISER_CONFIG = 'SET_ADVISER_CONFIG';
export const SET_HAS_TAX_OBLIGATIONS = 'SET_HAS_TAX_OBLIGATIONS';
export const SET_HAS_ACCEPTED_EXCLUSIONS = 'SET_HAS_ACCEPTED_EXCLUSIONS';
export const SET_SUSCRIPTION_CASE_ID = 'SET_SUSCRIPTION_CASE_ID';
export const SET_SUSCRIPTION_QUESTIONS = 'SET_SUSCRIPTION_QUESTIONS';
export const SET_SUSCRIPTION_ANSWERS = 'SET_SUSCRIPTION_ANSWERS';
export const SET_SUSCRIPTION_ENABLED = 'SET_SUSCRIPTION_ENABLED';
